// ----------------------------------------------------------------------------
// Component: Charity Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------


// Styles
import './_charity-block.scss';
import '../../snippets/_containers/css-grid/css-grid'

import $ from 'jquery';


// Constant elements
const TAB_BUTTON = '.tab--tabs';
const TAB_CONTENT = '.css-grid__item--tab';

// Constant trigger classes
const OPEN_CLASS = 'js-active';

// Open first tab on page load
$('.charity-block').each(function(index) {
    $(this).children(TAB_BUTTON).first().addClass(OPEN_CLASS);
    $(this).children(TAB_CONTENT).first().addClass(OPEN_CLASS);
});

function tabOpen(tab) {
    const $panel = tab.next(TAB_CONTENT);
    const hash   = '#' + $panel.attr('id');

    // Close all other Panels
    tab.siblings().removeClass(OPEN_CLASS);

    // Toggle the Current Panel
    if (tab.hasClass(OPEN_CLASS)) {
        tab.addClass(OPEN_CLASS);
        $panel.addClass(OPEN_CLASS);
    } else {
        tab.addClass(OPEN_CLASS);
        $panel.addClass(OPEN_CLASS);

        // Add the hash  to the URL
        if (history.pushState) {
            history.pushState(null, null, hash);
        } else {
            location.hash = hash;
        }

        if($(window).width() < 1025) {
            // // Scroll to the Panel portion when opening
            $('html, body').animate({
                scrollTop: $panel.offset().top - 180
            }, 500);
        }
    }
}

// Card opens Panel
$(TAB_BUTTON).on('click', function(event) {
    tabOpen($(this));
});

// Accessibility keypress opens Panel
$(TAB_BUTTON).keypress(function(event) {
    if (event.which == 13) {
        tabOpen($(this));
    }
});

// Close Button Closes Panel
$('.item--tab-close').on('click', function(event) {
    var $tab  = $(this).parents('.css-grid__item').prev('.tab--tabs');
    var $panel = $(this).parents('.css-grid__item--tab');

    // Close the relevant panel
    $card.removeClass(OPEN_CLASS);
    $panel.removeClass(OPEN_CLASS);
});

/**
 * keyboard navigation with tabs.
 * arrow up or right => open next tab
 * arrow down or bottom => open previous tab
 **/
const tablist = $(".charity-block").find("[role='tab']");

function tabsClickHandler(){  
  var thisTabId = $(this).attr('id');
  var thisTabList = $(this).parents("[role='tablist']").find("[role='tab']");  
  
  thisTabList.each(function(){ 
    var thisTabPanel = $("[role='tabpanel'][id='"+$(this).attr('aria-controls')+"']");
    if($(this).attr('id') == thisTabId){
      thisTabPanel.removeClass("hide"); 
      $(this).attr('aria-selected', true)
        .attr('tabindex', '0');   
    } else {  
      thisTabPanel.addClass("hide");
      $(this).attr('aria-selected', false)
        .attr('tabindex', '-1');
    }
  });
}

function tabsHandler(event){
  
  var index = tablist.index($(this));
  var numbTabs = tablist.length;
  var nextId;

  if(numbTabs>1){

    if(event.keyCode == 40 || event.keyCode == 39) { // DOWN or RIGHT
      nextId = tablist.eq(index+1);

      if(index == numbTabs-1){ // if it is the last not empty tab, then go to first not empty tab
        nextId = tablist.eq(0);
      }

      nextId.focus(); // focus on next tab
      nextId.click();
    }

    if(event.keyCode == 38 || event.keyCode == 37) { // UP or LEFT
      nextId = tablist.eq(index-1);

      if(index == 0){ // if it is the last not empty tab, then go to first not empty tab
        nextId = tablist.eq(numbTabs-1);
      }

      nextId.focus(); // focus on next tab
      nextId.click();
    }
  }
}

tablist.on('keydown', tabsHandler);
tablist.on('click', tabsClickHandler);

$("[role='tablist'][role='tab'][aria-selected='true']").click();
